<template>
  <v-container class="mt-2 pr-2" fluid>
    <v-row>
      <v-col cols="12">
	      <v-card class="shadowCard">
	        <v-card-title primary-title >
	          Catálogo de Usuarios

	          <v-spacer></v-spacer>
	          
	          <v-btn 
		          class="mr-2" 
		          small dark color="green"
		          @click="exportExcel( niveles  , 'escuelas_ERP')"
		          tile
		        >
		          <v-icon small>mdi-microsoft-excel</v-icon>
		        </v-btn>

		        <v-btn
		          color="primary"
		          dark
		          class="mr-2"
		          @click="dialog = true"
		          small
		          tile
		        >
		          <v-icon small>mdi-plus</v-icon>
		        </v-btn>

		        <v-btn
		          color="orange"
		          dark
		          class="text-capitalize"
		          @click="initialize()"
		          small
		          tile
		        >
		          <v-icon small>mdi-refresh</v-icon>
		        </v-btn>

	        </v-card-title>

	        <v-card-text>
	          <v-row justify="end">
				  		<v-col cols="12" md="8">
				  			<v-text-field
				  			  name="name"
				  			  label="Buscar"
				  			  id="id"
				  			  filled
				  			  dense
                  				  			  single-line
				  			  hide-details
				  			  append-icon="mdi-magnify"
				  			  v-model="search"
				  			>
				  			</v-text-field>
				  		</v-col>
				  	</v-row>

				  	<v-row>
			    		<v-col cols="12">

			          <v-data-table
			            :loading="cargar"        
			            :headers="headers"
			            :items="usuarios"
			            fixed-header
			            cargar-text="Cargando..."
			            dense
			            :search="search"
			          >

			            <template v-slot:item.estatus="{ item }" >
			              <v-chip small  dark :color="item.estatus ? 'green' : 'red'">ACTIVO</v-chip>
			            </template>

			            <template v-slot:item.editar="{ item }" >
			              <v-icon
			                small
			                class="mr-2"
			                @click="editItem(item)"
			              >
			                mdi-pencil
			              </v-icon>

			              <v-icon small @click="deleteItem(item)" color="error">
                      mdi-delete
                    </v-icon>
			            </template>

			          </v-data-table>
			        </v-col>
			      </v-row>
	        </v-card-text>
	              
	      </v-card>
	    </v-col>
    </v-row>  

    <v-row justify="center">
      <v-dialog v-model="modal" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Usuario</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente el usuario?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="modal = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteUsuario">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text class="px-0">
          <v-form 
          	class="my-0"
            ref="form" 
            v-model="valid"
            :lazy-validation="lazy"
          >
            <v-card-text>

              <v-text-field 
                :rules="nameRules"
                v-model="editedItem.nomuser" 
                color="secondary"
                clearable
                hide-details 
                append-icon="mdi-account" 
                label="Nombre" 
                filled dense 
                required
                class="mb-4"
              ></v-text-field>

              <v-autocomplete 
                class="mb-4"
                v-model="editedItem.idplanteles" 
                :items="planteles" 
                filled 
                append-icon="mdi-clipboard-account"
                label="Plantel" 
                hide-details 
                dense 
                item-text="plantel" 
                item-value="id_plantel"
              ></v-autocomplete>

              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.idpuestos"
                :items="puestos"
                label="Selecciona un puesto"
                persistent-hint
                item-text="puesto"
                item-value="idpuestos"
              >
              </v-autocomplete>

              <v-text-field 
                v-model="editedItem.email" 
                color="secondary"
                clearable
                hide-details 
                append-icon="mdi-email" 
                label="Usuario" 
                filled dense 
                required
                :rules="emailRules"
                class="mb-4"
              ></v-text-field>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="editedItem.fecha_ingreso" 
                    color="secondary"
                    hide-details 
                    label="Fecha ingreso" 
                    filled dense 
                    required
                    class="mb-4"
                    type="date"
                  ></v-text-field>
                </v-col>
              </v-row>

              <label>Datos de horario de ingreso</label>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="editedItem.hora_ingreso" 
                    color="secondary"
                    hide-details 
                    label="Hora ingreso" 
                    filled dense 
                    required
                    class="mb-4"
                    type="time"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="editedItem.hora_salida" 
                    color="secondary"
                    hide-details 
                    label="Hora salida" 
                    filled dense 
                    required
                    class="mb-4"
                    type="time"
                  ></v-text-field>
                </v-col>
              </v-row>

              <label>Datos de horario de comida</label>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="editedItem.hora_ingreso_fin" 
                    color="secondary"
                    hide-details 
                    label="Hora ingreso" 
                    filled dense 
                    required
                    class="mb-4"
                    type="time"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="editedItem.hora_salida_fin" 
                    color="secondary"
                    hide-details 
                    label="Hora salida" 
                    filled dense 
                    required
                    class="mb-4"
                    type="time"
                  ></v-text-field>
                </v-col>
              </v-row>

              <label>Describe el enfoque del empleado</label>
              <v-row>
                <v-col cols="12">
                  <v-textarea 
                    v-model="editedItem.enfoque" 
                    hide-details 
                    filled dense 
                    required
                    :rows="3"
                    auto.grow
                    class="mb-4"
                  ></v-textarea>
                </v-col>
              </v-row>


              <label>Ingresa la responsabilidades del empleado</label>
              <v-row>
                <v-col cols="12">
                  <v-textarea 
                    v-model="editedItem.responsabilidades" 
                    hide-details 
                    filled dense 
                    required
                    :rows="3"
                    auto.grow
                    class="mb-4"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-text-field
                v-if="editedIndex === -1"
                v-model="editedItem.password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                label="Contraseña"
                counter
                @click:append="show1 = !show1"
                dense
                filled
                color="secondary"
                clearable
                hide-details
                required
                :rules="[v => !!v || 'Item is required']"
                class="mb-4"
              ></v-text-field>

              <v-text-field
                v-if="editedIndex === -1"
                v-model="editedItem.password2"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                label="Confirma la contraseña"
                @click:append="show2 = !show2"
                filled
                color="secondary"
                clearable
                hide-details
                dense
                required
                :rules="[v => !!v || 'Item is required']"
                class="mb-4"
              ></v-text-field>

              <v-switch 
            		label="¿Activo Si/No?"
            		v-model="editedItem.estatus">
            	</v-switch>

              <v-btn 
              	small 
              	tile
              	dark 
              	color="red"  
              	@click="cambiaPassword = !cambiaPassword" v-if="cambiaPassword && editedIndex > -1"
              >
              	Cambiar Contraseña
              </v-btn>
              
              <v-btn 
              	tile 
              	small  
              	color="error" 
              	dark 
              	@click="cambiaPassword = !cambiaPassword" v-if="cambiaPassword == false && editedIndex > -1"
                class="mb-4"
              > 
            		Cancelar 
            	</v-btn>

              <v-text-field
              	v-if="!cambiaPassword"
                v-model="editedItem.password"
                :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                :type="show1 ? 'text' : 'password'"
                label="Contraseña"
                clearable
                filled
                dense
                @click:append="show1 = !show1"
                class="mb-4"
              ></v-text-field>
              
              <v-text-field
              	v-if="!cambiaPassword"
                v-model="editedItem.password2"
                :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
                :type="show2 ? 'text' : 'password'"
                label=" Confirmar Contraseña"
                clearable
                filled
                dense
                @click:append="show2 = !show2"
                class="mb-4"
              ></v-text-field>
            </v-card-text>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            @click="close"
            tile
            dense
          >
          	<v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            dark
            @click="save"
            tile
          >
          	<v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>


<script>
  var md5     = require('md5')
  import XLSX from 'xlsx'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      headers: [
        { text: 'ID'        , value: 'id'          },
        { text: 'Nombre'    , value: 'nomuser'     },
        { text: 'Plantel'   , value: 'plantel'     },
        { text: 'Antigüedad', value: 'antiguedad'  },
        { text: 'Usuario'   , value: 'email'       },
        // { text: 'Nivel'     , value: 'admin'       },  
        { text: 'Estatus'   , value: 'estatus'     },  
        { text: 'Depto'     , value: 'departamento'},  
        { text: 'Puesto'    , value: 'puesto'      },  
        { text: 'Acciones'  , value: 'editar'      },  
      ],

      search: '',
      usuarios: [],

      modal: false,
      ideliminar:0,

      dialog: false,
			editedIndex: -1,
      editedItem: {
        id: null,
        admin:'ADMIN',
        nomuser:'',
        apellidos:'',
        telmovil:'',
        email:'',
        empresa:'',
        telempresa:'',
        modmaquina:'',
        matserie:'',
        estatus:0,
        hora_ingreso:null,
        hora_salida:null,
        hora_ingreso_fin:null,
        hora_salida_fin:null,
        dia_descanso: null,
        fecha_ingreso: null,
        idpuestos: null,
        enfoque:null,
        responsabilidades:null,
        idplanteles:0,
      },
      defaultItem: {
        id: null,
        nomuser:'',
        admin:'ADMIN',
        apellidos:'',
        telmovil:'',
        email:'',
        empresa:'',
        telempresa:'',
        modmaquina:'',
        matserie:'',
        estatus:0,
        hora_ingreso:null,
        hora_salida:null,
        hora_ingreso_fin:null,
        hora_salida_fin:null,
        dia_descanso: null,
        fecha_ingreso: null,
        idpuestos: null,
        enfoque:null,
        responsabilidades:null,
        idplanteles:0,
      },

      valid:true,
      lazy: false,

      show: false,
      show1: false,
      show2: false,
      passwordActual:'',
      cambiaPassword:true,

      admin:{ clave:'', nombre:''},
      niveles: [{clave:'ADMIN', nombre:'Administrador'},{clave:'USUARIO',nombre:'Usuario'},{clave:'SUPERVISOR',nombre:'Supervisor'}],
      password:'',
      password2:'',
			nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 60) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required'
      ],

      planteles:[],
           
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo usuario' : 'Editar usuario'
      },
    },

    created () {
      // Inicializar aplicación
      this.initialize()
      this.getPuestos()
      this.getSucursales( )
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      // Editar el usuario, se recibe como parametro el usuario
      editar(item){
        this.$router.push({name:'newusuario', params: {id: item.id}})
      },

      initialize () {
        this.cargar = true
        //Consultar Usuarios
        this.usuarios = []
        this.$http.get('users').then( response => {
          this.cargar = false
          this.usuarios = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },  

      getSucursales () {
        this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.list.erp').then(response=>{
          this.planteles = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },


      getPuestos () {
        this.cargar = true
        this.puestos = []
        return this.$http.get('puestos.list').then(response=>{
          this.puestos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteItem(item) {
	      this.editedIndex = this.reglas.indexOf(item);
	      this.editedItem = Object.assign({}, item);
	      this.dialogDelete = true;
	    },

	    deleteItemConfirm() {
	      // Lo mandapos por el EP
	      this.editedItem.deleted = 1;
	      this.$http.put("reglamento.escuela.update/" + this.editedItem.idreglamento, this.editedItem ).then((response) => {
          this.dialogSuccess = true;
          this.cargar = false;
          this.closeDelete();
          this.initialize();
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
	    },

      deleteUsuario(){
        // Eliminar usuario
        this.$http.delete('usuario.delete/' + this.ideliminar).then(response=>{
          this.text = 'Usuario eliminado correctamente'
          this.color = 'success'
          this.snackbar = true
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.usuarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.passwordActual = this.editedItem.password
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.cargar = true
        if (this.editedIndex > -1) {

	        this.editedItem.password = this.cambiaPassword ? this.passwordActual : md5(this.editedItem.password)

	        this.$http.post('update.usuario', this.editedItem).then( response => {
	         this.validarSuccess('Usuario actualizado correctamente')
	          // Volvemos a cargar correctamente la información del usuario
        		this.close()
	          this.initialize(this.id)
	        }).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })

        } else {
          this.$http.post('user.add',this.editedItem).then(response=>{
            this.validarSuccess('Usuario agregado correctamente')
        		this.close()
            this.initialize()
          }).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
        }
      },

    },

  }
</script>